import axios from "axios";

const API_URL = import.meta.env.VITE_API_URL;

const CompressionService = {
    getDimensions: async () => axios.get(API_URL + "/compression/getDimensions").then(({ data }) => data).catch((err) => { throw err }),

    getPreviewLanes: async () => axios.get(API_URL + "/compression/getPreviewLanes").then(({ data }) => data).catch((err) => { throw err }),

    getConfig: async () => axios.get(API_URL + "/compression/config").then(({ data }) => data).catch((err) => { throw err}),

    getNewImage: async (formData) => axios.post(API_URL + "/compression/getNewImage", formData).then(({ data }) => data).catch((err) => { throw err }),

    save: async (formData) => axios.post(API_URL + "/compression/save", formData).then(({ data }) => data).catch((err) => { throw err }),
}

export default CompressionService;